<svg [ngClass]='cssClasses' [style.transform]="rotate" width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
  <path d='M29 7L17 19L12 14L3 23' stroke='#898D90' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' />
  <path d='M29 15V7H21' stroke='#898D90' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' />
</svg>
